// src/config.js
export const API_BASE = process.env.API_URL || 'http://localhost:5001';